function AuthenticationLayout(props){
    return props.children
}
export default AuthenticationLayout; 